import React, { Component } from 'react';

const Motivational = () => {
  return (
    <div className="content column animated fadeIn has-text-centered" style={{ animationDelay: '1s' }}>
      <p>Have a nice day!</p>
    </div>
  );
};

export default Motivational;



// WEBPACK FOOTER //
// ./app/components/Motivational/index.js